<fad-provider-details
  class="provider-detail"
  [attr.npi]="providerNPI"
  [attr.configuration-url]="configurationUrl"
  [attr.referring-url]="currentRoute"
  [attr.embedSource]="embedSource"
  [attr.base-url]="baseUrl"
>
</fad-provider-details>
